import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  DataContainer,
  MediaWrapper,
  MediaImageWrapper,
  MediaTextWrapper,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Typography} from '@fupa/fupa-uikit';
import {ExternalLink} from 'app/components/start/startStyles';
import styled from 'styled-components';

const sportVideoConfig = {
  title: 'FuPa.tv ist zurück! 🤩🎥',
  text: 'Deine Highlights - in Echtzeit - direkt hier! Filmt eure Partie kostenlos über die Sport.Video-App!',
  icon: {
    src: '/sportvideo.svg',
    size: 18,
  },
  image: {
    src: '/sport-video-teaser-2.png',
    size: 64,
  },
};
const BADGE_HEIGHT = 40;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  img {
    margin: 0.25rem 0;
  }
`;
const SportVideoTeaser = () => {
  const APPLE_APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id1241795100?pt=118064739&ct=fupa&mt=8';
  const GOOGLE_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.sportvideo.android.recorder&referrer=utm_source%3Dfupa';
  const {title, text, image, icon} = sportVideoConfig;
  return (
    <Content>
      <Container>
        <EventInformation customBgColor={COLORS.fupaPrimary}>
          <img style={{marginLeft: '2px'}} width={icon.size} height={icon.size} src={icon.src} alt='Sport.Video' />
        </EventInformation>
        <DataContainer>
          <Typography variant='body1'>{title}</Typography>
          <MediaWrapper>
            <MediaTextWrapper>
              <Typography variant='body2'>{text}</Typography>
            </MediaTextWrapper>
            <MediaImageWrapper>
              <img width={image.size} height={image.size} src={image.src} alt='Sport.Video' />
            </MediaImageWrapper>
          </MediaWrapper>
          <Wrapper>
            <ExternalLink href={APPLE_APP_STORE_URL} target='_blank'>
              <img height={BADGE_HEIGHT} alt='Laden im App Store' src='/badge/app-store-badge.svg' />
            </ExternalLink>
            <ExternalLink href={GOOGLE_PLAY_STORE_URL} target='_blank'>
              <img height={BADGE_HEIGHT + 12} alt='Jetzt bei Google Play' src='/badge/google-play-badge.svg' />
            </ExternalLink>
          </Wrapper>
        </DataContainer>
      </Container>
    </Content>
  );
};

export default SportVideoTeaser;
